import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-move-left', 'IconArrowMoveLeft', [
  ['path', { d: 'M13 12h-10', key: 'svg-0' }],
  ['path', { d: 'M6 15l-3 -3l3 -3', key: 'svg-1' }],
  ['path', { d: 'M17 12a2 2 0 1 1 4 0a2 2 0 0 1 -4 0z', key: 'svg-2' }],
]);
